import { formatCurrency } from '@utils/formatters';

export const MONTHS = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];
export const MONTHS_SHORT = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];
export const CAT_COLORS = ['#0ea5e9','#22c55e','#f59e0b','#8b5cf6','#ef4444','#ec4899','#14b8a6','#f97316'];

export const formatCompact = (n) => {
  if (n == null) return '—';
  const abs = Math.abs(n);
  if (abs >= 1_000_000) return `R$${(n / 1_000_000).toFixed(1)}M`;
  if (abs >= 1_000) return `R$${(n / 1_000).toFixed(1)}k`;
  return formatCurrency(n);
};

export const pct = (a, b) => (b && b !== 0 ? ((a - b) / Math.abs(b)) * 100 : 0);

export const savingsColor = (rate) => {
  if (rate >= 20) return { text: 'text-emerald-500', ring: '#10b981', label: 'Excelente' };
  if (rate >= 10) return { text: 'text-green-500', ring: '#22c55e', label: 'Bom' };
  if (rate >= 0) return { text: 'text-yellow-500', ring: '#f59e0b', label: 'Regular' };
  return { text: 'text-red-500', ring: '#ef4444', label: 'Atenção' };
};
